import { render, staticRenderFns } from "./ContatoAluno.vue?vue&type=template&id=b6f1b076&scoped=true&"
import script from "./ContatoAluno.vue?vue&type=script&lang=js&"
export * from "./ContatoAluno.vue?vue&type=script&lang=js&"
import style0 from "./ContatoAluno.vue?vue&type=style&index=0&id=b6f1b076&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f1b076",
  null
  
)

export default component.exports